// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__rSYI2","row":"Node_row__3eo8i","label":"Node_label__3ZsIP","footer":"Node_footer__2VKU1"};